// @ts-nocheck -- react-easy-crop relies on upstream React declarations unavailable in this migration.
import { useState } from 'react';
import Cropper from 'react-easy-crop';
import Modal from '../../../../../shared/components/Modal';

type CropModalProps = {
  src: string;
  onDone: (avatar: string) => void;
  onClose: () => void;
  t: any;
};

export default function CropModal({ src, onDone, onClose, t }: CropModalProps) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [pixels, setPixels] = useState<any>();

  const finish = () => {
    if (!pixels) return;

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) return;

      canvas.width = 400;
      canvas.height = 400;
      context.drawImage(
        image,
        pixels.x,
        pixels.y,
        pixels.width,
        pixels.height,
        0,
        0,
        400,
        400,
      );
      onDone(canvas.toDataURL('image/jpeg', 0.9));
    };
    image.src = src;
  };

  return (
    <Modal onClose={onClose}>
      <div className="modal-head">
        <span className="eyebrow coral">{t.profilePhoto}</span>
        <h2>{t.positionCrop}</h2>
      </div>
      <div className="crop-wrap">
        <Cropper
          image={src}
          crop={crop}
          zoom={zoom}
          aspect={1}
          cropShape="round"
          showGrid
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={(_: any, nextPixels: any) => setPixels(nextPixels)}
        />
      </div>
      <label className="range">
        {t.zoom}
        <input
          type="range"
          min="1"
          max="3"
          step=".1"
          value={zoom}
          onChange={(event: any) => setZoom(Number(event.target.value))}
        />
      </label>
      <div className="modal-actions">
        <button className="secondary" onClick={onClose}>{t.cancel}</button>
        <button className="primary" onClick={finish}>{t.usePhoto}</button>
      </div>
    </Modal>
  );
}
